import {
  DeletePromotion,
  DeletePromotionVariables,
} from "_graphql/mutation/__generated__/DeletePromotion";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import { deletePromotion } from "_graphql/visal/mutations/promotions";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";

export default function RemovePromotionContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const [remove, { loading }] = useMutation<
    DeletePromotion,
    DeletePromotionVariables
  >(deletePromotion, {
    refetchQueries: ["GetPromotions"],
  });

  const handleSubmit = async () => {
    await remove({
      variables: {
        input: {
          id: searchParams?.id || "",
        },
      },
    }).then(({ data }) => {
      if (data?.deletePromotion) {
        toast.success("Campaign removed successfully");
        refetch?.();
        setOpen?.(false);
      } else {
        toast.error("Failed to remove campaign");
      }
    });
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title="Remove Campaign"
      cancelText="No, Don't Remove Campaign"
      description="This action would completely remove campaign details from system"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={handleSubmit}
          >
            {loading ? "Removing Campaign..." : "Remove Campaign"}
          </button>
        </>
      )}
    />
  );
}
